import { Label } from '@ui/primitives/Label'
import { Input, type InputProps } from '@ui/primitives/Input'

interface FormFieldProps extends InputProps {
  label: string
  name: string
  required?: boolean
  error?: string
}

export function FormField({ label, name, required, error, ...inputProps }: FormFieldProps) {
  return (
    <div className="space-y-1">
      <Label htmlFor={name} required={required}>
        {label}
      </Label>
      <Input id={name} name={name} error={error} {...inputProps} />
    </div>
  )
}
